import Navbar from '../components/cummon/Navbar';

import Footer from '../components/cummon/Footer';

import RdvSection from '../components/rdv/rdvSection';



function RdvPage() {
  return (
    <div className="min-h-screen  bg-white">
      <Navbar />
       
        <RdvSection />
      
      <Footer />
      
    
    
    </div>
  );
}

export default RdvPage;